export default (component, id) => ({
    showEdit: component.entangle('showEdit'),
    showEditWithoutDefer: component.entangle('showEdit').live,
    editLoaded: component.entangle('editLoaded').live,

    init() {
        window.addEventListener(`close-edit::${id}`, () => this.showEdit = false);

        this.$watch('showEdit', (value) => {
            if (value) {
                this.$store.editMode.edit(`info-${id}`);
            } else {
                this.$dispatch('editMode::reset');
            }
        })
    },

    openEdit: function () {
        if (!this.editLoaded) {
            this.showEditWithoutDefer = true;
        } else {
            this.showEdit = true;
        }
    },

    closeEdit: function () {
        this.showEdit = false;
    }
})
